import { z } from 'zod';

export const consentStatusSchema = z.enum(['opted_in', 'opted_out']);
export type ConsentStatus = z.infer<typeof consentStatusSchema>;

export const messageStatusSchema = z.enum([
  'queued',
  'processing',
  'sent',
  'delivered',
  'read',
  'failed',
  'cancelled',
]);
export type MessageStatus = z.infer<typeof messageStatusSchema>;

/** Statuses ranked so out-of-order webhooks never downgrade a message. */
export const MESSAGE_STATUS_RANK: Record<MessageStatus, number> = {
  queued: 0,
  processing: 1,
  sent: 2,
  delivered: 3,
  read: 4,
  failed: 5,
  cancelled: 5,
};

export const consentSourceSchema = z.enum([
  'web_form',
  'erp_import',
  'dashboard',
  'paper_form',
  'inbound_stop',
  'api',
]);
export type ConsentSource = z.infer<typeof consentSourceSchema>;

export const templateStatusSchema = z.enum([
  'APPROVED',
  'PENDING',
  'REJECTED',
  'PAUSED',
  'DISABLED',
  // Meta no longer returns it. The row is kept because messages reference it,
  // but it must never be offered for sending again.
  'DELETED',
]);
export type TemplateStatus = z.infer<typeof templateStatusSchema>;

export const templateCategorySchema = z.enum(['UTILITY', 'MARKETING', 'AUTHENTICATION']);
export type TemplateCategory = z.infer<typeof templateCategorySchema>;

export const headerTypeSchema = z.enum(['NONE', 'TEXT', 'DOCUMENT', 'IMAGE']);
export type HeaderType = z.infer<typeof headerTypeSchema>;

export const userRoleSchema = z.enum(['admin', 'ops']);
export type UserRole = z.infer<typeof userRoleSchema>;

export const messageEventSchema = z.enum([
  'queued',
  'attempt',
  'sent',
  'delivered',
  'read',
  'failed',
  'retry',
  'cancelled',
  'deferred',
]);
export type MessageEventName = z.infer<typeof messageEventSchema>;

export const apiKeyScopeSchema = z.enum([
  'messages:write',
  'messages:read',
  'recipients:read',
  'recipients:write',
  'templates:read',
]);
export type ApiKeyScope = z.infer<typeof apiKeyScopeSchema>;
